
export type GetTweetsSortDirection = typeof GetTweetsSortDirection[keyof typeof GetTweetsSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetsSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
